module.exports = __webpack_public_path__ + "static/media/ic_my_approval.15db3b06.png";